import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { IconComponent } from '../../../../../../../../shared/components/ui/icon/icon.component';
import { TranslatePipe } from '../../../../../../../../shared/pipes/translate/translate.pipe';
import { ChecklistQuestionCategory, ChecklistQuestionGroup } from '../../interfaces/checklists-question.interface';
import { NgClass } from '@angular/common';

@Component({
  selector: 'bizz-checklist-sidebar',
  standalone: true,
  imports: [
    IconComponent,
    TranslatePipe,
    NgClass,
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})

export class ChecklistSidebarComponent {
  @Input() public formId: string;
  @Input() public activeGroup: { group: ChecklistQuestionGroup, questions: number[], checkedQuestions: number};
  @Input() public groups: { group: ChecklistQuestionGroup, questions: number[], checkedQuestions: number }[];
  @Output() public groupChanged = new EventEmitter<{ group: ChecklistQuestionGroup, questions: number[],checkedQuestions: number}>()
  
  public setGroupAsActive(item: { group: ChecklistQuestionGroup, questions: number[], checkedQuestions: number}): void {
    this.groupChanged.emit(item);
  }

}
